import getPlainText from '@/client/services/richText/getPlainText'

import getMessageConfig from './getMessageConfig'
import type { MessageBody, MessageType } from './types'

export function getMessagePlainText({
  type,
  body,
}: {
  type: MessageType | null
  body: MessageBody | null
}): string {
  const config = getMessageConfig({ type, body })

  if (config == null) {
    return ''
  }

  if (config.type === 'embed-v1') {
    if (config.body.embed === 'assessment') {
      return '[EMBEDDED ASSESSMENT]'
    }

    return '[EMBEDDED RESOURCE]'
  }

  return getPlainText(config.body)
}
